import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "forecast-diff-header" }
const _hoisted_2 = { class: "forecast-diff-header__current-month" }
const _hoisted_3 = {
  key: 0,
  class: "table-header__sortable-content forecast-diff-header__column-type"
}
const _hoisted_4 = { class: "table-header__text" }
const _hoisted_5 = {
  key: 1,
  class: "table-header__text"
}

import { i18n } from '@/i18n';
import TableHead from '../TableHead.vue';
import { TableContentProperty } from '../../interface/tableContentHeaders';
import ArrowIcon from '../../components/ArrowIcon.vue';
import { IYearMonth } from '@/coreDomainsModule/date';
import { ForecastDiffLastMonthTableContentViewModel } from './forecastDiffLastMonthTableContentViewModel';
import { computed } from 'vue';
import { ForecastDiffLastMonthService } from './domains/services/forecastDIffLastMonthService';
// props

export default /*@__PURE__*/_defineComponent({
  __name: 'ForecastDiffLastMonthTableHead',
  props: {
    header: {},
    headerIndex: {},
    accumulationTableContentWidth: {},
    isVariableWidth: { type: Boolean },
    isAllSelected: { type: Boolean },
    stableColumnCount: {},
    forecastStartYearMonth: { default: undefined }
  },
  emits: ["onClickSort", "onMousedownResizer"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const forecastDiffLastMonthTableCellVM = new ForecastDiffLastMonthTableContentViewModel();

// emits
const emits = __emit;
//変数
const t = i18n.t;

const columnType = computed(() => {
  return ForecastDiffLastMonthService.getColumnType(props.header.key);
});

/**
 * ソートアイコンクリック時
 */
const onClickedSort = () => {
  emits('onClickSort', props.headerIndex, props.header, props.header.sortOption.isAsc);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TableHead, {
    class: _normalizeClass(["forecast-diff-header-container", [
      _unref(forecastDiffLastMonthTableCellVM).isSticky(_ctx.stableColumnCount, _ctx.headerIndex) ? 'sticky-content' : '',
      columnType.value === 'diffAmount' ? 'forecast-diff-header-container--border-right' : '',
    ]]),
    style: _normalizeStyle({
      left: _unref(forecastDiffLastMonthTableCellVM).calcStickyDiff(_ctx.stableColumnCount, _ctx.headerIndex, _ctx.accumulationTableContentWidth),
    }),
    index: _ctx.headerIndex,
    resizable: 
      // 幅可変な列 && 固定する列に含まれていない -> 可変幅
      _ctx.header.isVariableWidth && !_unref(forecastDiffLastMonthTableCellVM).isSticky(_ctx.stableColumnCount, _ctx.headerIndex)
    ,
    onOnMousedownResizer: _cache[1] || (_cache[1] = ($event) => emits('onMousedownResizer', $event, _ctx.headerIndex))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(columnType.value === 'currentMonthAmount' ? _unref(t)(_unref(forecastDiffLastMonthTableCellVM).getHeaderText(_ctx.header.key, _ctx.forecastStartYearMonth)) : ''), 1),
        (_ctx.header.sortOption.isSortable)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(forecastDiffLastMonthTableCellVM).getForecastDiffHeaderText(columnType.value)), 1),
              _createVNode(ArrowIcon, {
                asc: _ctx.header.sortOption.isAsc,
                onOnClick: _cache[0] || (_cache[0] = ($event: any) => (emits('onClickSort', _ctx.headerIndex, _ctx.header, _ctx.header.sortOption.isAsc)))
              }, null, 8, ["asc"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_unref(forecastDiffLastMonthTableCellVM).getForecastDiffHeaderText(columnType.value)), 1))
      ])
    ], undefined, true),
    _: 1
  }, 8, ["class", "style", "index", "resizable"]))
}
}

})